import request from "@/utils/request-axios";
import api from '@/utils/api'


//财粮说我的动态
export function getMyQuotation(params) {
  return request(`${api.getMyQuotation}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//获取我的个人信息
export function getPersonInfo(params) {
  return request(`${api.getPersonInfo}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//财粮说我的收藏的报价单
export function getMyCollect(params) {
  return request(`${api.getMyCollect}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//财粮说我的草稿
export function getMyDraft(params) {
  return request(`${api.getMyDraft}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//编辑草稿
export function editDraftQuotation(params) {
  return request(`${api.editDraftQuotation}`, {
    loading: true,
    method: 'put',
    data: params,
    promptMessage: "编辑成功!",
  });
}

//编辑草稿
export function editRowQuotation(params) {
  return request(`${api.editRowQuotation}`, {
    loading: true,
    method: 'post',
    data: params,
    promptMessage: "编辑成功!",
  });
}


//删除报价单
export function deleteQuotation(params) {
  return request(`${api.deleteQuotation}${params}`, {
    loading: true,
    method: 'delete',
    promptMessage: "删除报价单成功!",
  });
}

//收藏报价单
export function collectQuotation(params) {
  return request(`${api.collectQuotation}${params}`, {
    loading: true,
    method: 'post',
    promptMessage: "收藏报价单成功!",
  });
}

//取消收藏报价单
export function cancelCollectQuotation(params) {
  return request(`${api.cancelCollectQuotation}${params}`, {
    loading: true,
    method: 'put',
    promptMessage: "取消收藏成功!",
  });
}

//获取我的详情
export function getUserDetails(params) {
  return request(`${api.getUserDetails}${params}`, {
    loading: true,
    method: 'get'
  });
}

//修改个人信息
export function updateUser(params) {
  return request(`${api.updateUser}`, {
    loading: true,
    method: 'put',
    data: params.params
  });
}


//微信解绑
export function unbindWx(params) {
  return request(`${api.unbindWx}${params}`, {
    loading: true,
    method: 'get',
  });
}

//获取微信绑定二维码
export function getBoundCode() {
  return request(`${api.getBoundCode}`, {
    loading: true,
    method: 'get',
  });
}

//获取微信绑定二维码状态
export function getBoundStatus(id) {
  return request(`${api.getBoundStatus}?identitySid=${id}`, {
    loading: true,
    method: 'get',
  });
}







// WEBPACK FOOTER //
// ./src/services/dynamic/dynamicMy.js